<template>
    <div v-if="paymentMethods && paymentMethods.pix" class="pt-2">
        <p>
            Após realizar o pagamento do Pix, ele será confirmado pelo banco e seu pedido entrará em
            produção.
        </p>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentPix',

        props: ['cart', 'customer', 'paymentMethods'],

        data() {
            let methods = [
                {
                    label: 'À vista',
                    total_installments: 0,
                },
            ];

            return {
                selectedMethod: methods[0],
                methods,
            };
        },

        computed: {
            description() {
                if (this.selectedMethod) {
                    return `Pix - ${this.selectedMethod.label}`;
                } else {
                    return 'Pix';
                }
            },
        },

        methods: {
            submit(callback) {
                callback({
                    module: 'pix',
                    installments: this.selectedMethod.total_installments,
                });
            },
        },
    };
</script>
